<template><!-- svgo-optimised -->
<svg class="icon icon__filter" viewBox="0 0 8 7" xmlns="http://www.w3.org/2000/svg"><path d="M2 0h1v3H2z"/><path d="M8 1v1H0V1zM5 4h1v3H5z"/><path d="M8 5v1H0V5z"/></svg></template>